import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { curriculumActions } from '@store/curriculum/curriculumState';

type DistributeState = Readonly<{
  filters: {
    text: string;
  };
  distributionMode: boolean;
}>;

const initialState: DistributeState = {
  filters: {
    text: '',
  },
  distributionMode: false,
};

const distributeState = createSlice({
  name: 'distribute',
  initialState,
  reducers: {
    setFilter: (state, action) => {
      const { property, value } = action.payload;
      state.filters[property] = value;
    },
    setDistributionMode: (state, action) => {
      state.distributionMode = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(curriculumActions.setSelectionMode, (state, action: PayloadAction<boolean>) => {
      if (action.payload) {
        // you can't be in selection mode and distribution mode at the same time
        state.distributionMode = false;
      }
    });
  },
});

export const { setFilter, setDistributionMode } = distributeState.actions;
export default distributeState;
